import { Link, NavLink } from "react-router-dom";
import { LOGO_URL } from "@/lib/constants";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/book", label: "Book Repair" },
    { to: "/shop", label: "Shop" },
    { to: "/track", label: "Track Job" },
    { to: "/reviews", label: "Reviews" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-spark-line" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-stretch justify-between gap-4">
        {/* Logo overhangs the bottom edge */}
        <Link to="/" className="flex items-start gap-3 self-start pt-1.5 z-10" data-testid="navbar-logo-link">
          <img
            src={LOGO_URL}
            alt="Spark Scooter Repairs"
            className="h-20 w-20 sm:h-24 sm:w-24 lg:h-28 lg:w-28 rounded-full ring-4 ring-spark-yellow shadow-lg shrink-0"
            data-testid="navbar-logo-img"
          />
          <div className="flex flex-col leading-tight pt-2.5 sm:pt-3 lg:pt-4">
            <span className="font-display text-sm sm:text-base lg:text-lg font-bold text-spark-ink uppercase">Spark Scooter</span>
            <span className="label-mono text-spark-teal text-[10px] sm:text-[11px]">Repairs · NZ</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `font-display uppercase tracking-wider text-sm font-semibold transition-colors ${
                  isActive ? "text-spark-teal" : "text-spark-ink hover:text-spark-teal"
                }`
              }
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/admin/login" className="label-mono hover:text-spark-teal" data-testid="nav-link-admin">
            Admin
          </Link>
        </nav>

        <button
          type="button"
          className="lg:hidden p-2 self-center"
          onClick={() => setOpen((v) => !v)}
          data-testid="navbar-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="size-6" /> : <Menu className="size-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-spark-line bg-white" data-testid="navbar-mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-display uppercase tracking-wider text-base ${
                    isActive ? "text-spark-teal" : "text-spark-ink"
                  }`
                }
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              className="label-mono"
              data-testid="nav-mobile-admin"
            >
              Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
